// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from '../../Api/ApiUrls';

// const MatchingBuyersPage = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const [buyers, setBuyers] = useState([]);
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [categories, setCategories] = useState([]);
//   const [users, setUsers] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
        
//         // 1. Fetch all properties to find our property
//         const propertiesResponse = await axios.get(`${BASE_URL}/property/`);
//         const foundProperty = propertiesResponse.data.find(
//           p => p.property_id == propertyId
//         );
        
//         if (!foundProperty) {
//           console.error('Property not found');
//           setLoading(false);
//           return;
//         }
        
//         setProperty(foundProperty);
        
//         // 2. Fetch categories
//         const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
//         setCategories(categoriesResponse.data);
        
//         // 3. Fetch all enquiries
//         const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
//         const allEnquiries = enquiriesResponse.data;
        
//         // 4. Fetch all users to get user details
//         const usersResponse = await axios.get(`${BASE_URL}/users/`);
//         setUsers(usersResponse.data);
        
//         // Get the property category name
//         const propertyCategory = categoriesResponse.data.find(
//           cat => cat.category_id == foundProperty.category_id
//         )?.category;
        
//         // Filter matching buyers
//         const matchingBuyers = allEnquiries.filter(enquiry => {
//           // Get user details for this enquiry
//           const enquiryUser = usersResponse.data.find(
//             user => user.user_id == enquiry.user_id
//           );
          
//           if (!enquiryUser) return false;
          
//           // 1. Property Type Match (compare enquiry.property_type with property category)
//           const typeMatch = enquiry.property_type && propertyCategory && 
//             enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();
          
//           // 2. Location Match (case insensitive partial match)
//           const locationMatch = enquiry.area && foundProperty.location && 
//             (enquiry.area.toLowerCase().includes(foundProperty.location.toLowerCase()) || 
//              foundProperty.location.toLowerCase().includes(enquiry.area.toLowerCase()));
          
//           // 3. Budget Match (with ±20% flexibility)
//           const budgetMatch = enquiry.budget && foundProperty.price &&
//             (enquiry.budget >= foundProperty.price * 0.8 && 
//              enquiry.budget <= foundProperty.price * 1.2);
          
//           return typeMatch || locationMatch || budgetMatch;
//         }).map(enquiry => ({
//           ...enquiry,
//           user: usersResponse.data.find(user => user.user_id == enquiry.user_id)
//         }));
        
//         setBuyers(matchingBuyers);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchData();
//   }, [propertyId]);

//   if (loading) return <div>Loading...</div>;
//   if (!property) return <div>Property not found</div>;

//   return (
//     <div style={{ padding: '20px' }}>
//       <button onClick={() => navigate(-1)} style={{ marginBottom: '20px' }}>
//         ← Back
//       </button>
      
//       <h2>Matching Buyers for {property.property_name || 'Property'}</h2>
      
//       <div style={{ marginBottom: '30px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
//         <h3>Property Details:</h3>
//         <p><strong>Type:</strong> {property.type}</p>
//         <p><strong>Location:</strong> {property.location}</p>
//         <p><strong>Price:</strong> ₹{property.price?.toLocaleString()}</p>
//         <p><strong>Category:</strong> {
//           categories.find(cat => cat.category_id == property.category_id)?.category || 'N/A'
//         }</p>
//         <p><strong>Area:</strong> {property.site_area} sq ft</p>
//       </div>
      
//       <h3>Matching Buyers ({buyers.length})</h3>
      
//       {buyers.length > 0 ? (
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
//           {buyers.map((buyer, index) => (
//             <div key={index} style={{ border: '1px solid #eee', borderRadius: '8px', padding: '15px' }}>
//               <h4 style={{ marginTop: 0 }}>{buyer.user?.name || 'Anonymous Buyer'}</h4>
//               <p><strong>Contact:</strong> {buyer.user?.mobile || 'N/A'}</p>
//               <p><strong>Email:</strong> {buyer.user?.email || 'N/A'}</p>
//               <p><strong>Looking for:</strong> {buyer.property_type}</p>
//               <p><strong>Preferred Area:</strong> {buyer.area}</p>
//               <p><strong>Budget:</strong> ₹{buyer.budget?.toLocaleString()}</p>
//               <p><strong>Enquiry Date:</strong> {new Date(buyer.created_at).toLocaleDateString()}</p>
//               <button 
//                 onClick={() => navigate(`/user-profile/${buyer.user_id}`)}
//                 style={{ marginTop: '10px', padding: '5px 10px' }}
//               >
//                 View Profile
//               </button>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <p>No matching buyers found for this property.</p>
//       )}
//     </div>
//   );
// };

// export default MatchingBuyersPage;






// import {
//   Box,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Container,
//   Card,
//   CardContent,
//   List,
//   ListItem,
//   ListItemText,
//   Divider
// } from '@mui/material';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from '../../Api/ApiUrls';

// const MatchingBuyersPage = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const [buyers, setBuyers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [categories, setCategories] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [property, setProperty] = useState(null);

//   // Haversine formula to calculate distance between two coordinates
//   const calculateDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371; // Earth's radius in km
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a = 
//       Math.sin(dLat/2) * Math.sin(dLat/2) +
//       Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
//       Math.sin(dLon/2) * Math.sin(dLon/2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
//     return R * c; // Distance in km
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
        
//         // 1. Fetch all properties to find our property
//         const propertiesResponse = await axios.get(`${BASE_URL}/property/`);
//         const foundProperty = propertiesResponse.data.find(
//           p => p.property_id == propertyId
//         );
        
//         if (!foundProperty) {
//           console.error('Property not found');
//           setLoading(false);
//           return;
//         }
        
//         setProperty(foundProperty);
        
//         // 2. Fetch categories
//         const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
//         setCategories(categoriesResponse.data);
        
//         // 3. Fetch all enquiries
//         const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
//         const allEnquiries = enquiriesResponse.data;
        
//         // 4. Fetch all users to get user details
//         const usersResponse = await axios.get(`${BASE_URL}/users/`);
//         setUsers(usersResponse.data);
        
//         // Get the property category name
//         const propertyCategory = categoriesResponse.data.find(
//           cat => cat.category_id == foundProperty.category_id
//         )?.category;
        
//         // Parse property coordinates
//         const parseCoord = (coord) => {
//           if (!coord) return null;
//           const cleaned = coord.replace(/"/g, '').replace(':', '.');
//           return parseFloat(cleaned);
//         };
        
//         const propLat = parseCoord(foundProperty.lat);
//         const propLong = parseCoord(foundProperty.long);
        
//         // Filter matching buyers with all three criteria
//         const matchingBuyers = allEnquiries.filter(enquiry => {
//           // Get user details for this enquiry
//           const enquiryUser = usersResponse.data.find(
//             user => user.user_id == enquiry.user_id
//           );
          
//           if (!enquiryUser) return false;
          
//           // 1. Property Type Match (compare enquiry.property_type with property category)
//           const typeMatch = enquiry.property_type && propertyCategory && 
//             enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();
          
//           // 2. Budget Match - Updated for range matching
//           const budgetMatch = (() => {
//             if (!foundProperty.price) return false;
            
//             // Case 1: Enquiry has both min and max budget
//             if (enquiry.min_budget && enquiry.max_budget) {
//               return foundProperty.price >= enquiry.min_budget && 
//                      foundProperty.price <= enquiry.max_budget;
//             }
            
//             // Case 2: Enquiry has only min budget (e.g., "2Cr+")
//             if (enquiry.min_budget && !enquiry.max_budget) {
//               return foundProperty.price >= enquiry.min_budget;
//             }
            
//             // Case 3: Enquiry has only max budget (unlikely but handle it)
//             if (!enquiry.min_budget && enquiry.max_budget) {
//               return foundProperty.price <= enquiry.max_budget;
//             }
            
//             // Case 4: No budget specified in enquiry (fallback to old single budget field)
//             if (enquiry.budget) {
//               return foundProperty.price >= enquiry.budget * 0.8 && 
//                      foundProperty.price <= enquiry.budget * 1.2;
//             }
            
//             return false;
//           })();
          
//           // 3. Location Match using lat/long (within 10km radius)
//           const locationMatch = (() => {
//             if (!propLat || !propLong || !enquiry.lat || !enquiry.long) return false;
            
//             try {
//               const enqLat = parseFloat(enquiry.lat);
//               const enqLong = parseFloat(enquiry.long);
//               const distance = calculateDistance(propLat, propLong, enqLat, enqLong);
//               return distance <= 10; // 10km radius
//             } catch (e) {
//               console.error('Error calculating distance:', e);
//               return false;
//             }
//           })();
          
//           // Count as match if all three criteria are met
//           return typeMatch && budgetMatch && locationMatch;
//         }).map(enquiry => ({
//           ...enquiry,
//           user: usersResponse.data.find(user => user.user_id == enquiry.user_id),
//           // Format budget display
//           formattedBudget: formatBudgetDisplay(enquiry),
//           // Calculate and include distance
//           distance: (() => {
//             if (!propLat || !propLong || !enquiry.lat || !enquiry.long) return 'N/A';
//             try {
//               const enqLat = parseFloat(enquiry.lat);
//               const enqLong = parseFloat(enquiry.long);
//               return `${calculateDistance(propLat, propLong, enqLat, enqLong).toFixed(1)} km`;
//             } catch (e) {
//               return 'N/A';
//             }
//           })()
//         }));
        
//         setBuyers(matchingBuyers);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchData();
//   }, [propertyId]);

//   // Helper function to format budget display
//   const formatBudgetDisplay = (enquiry) => {
//     if (enquiry.min_budget && enquiry.max_budget) {
//       return `₹${(enquiry.min_budget/100000).toLocaleString()}L - ₹${(enquiry.max_budget/100000).toLocaleString()}L`;
//     }
//     if (enquiry.min_budget && !enquiry.max_budget) {
//       return `₹${(enquiry.min_budget/10000000).toLocaleString()}Cr+`;
//     }
//     if (!enquiry.min_budget && enquiry.max_budget) {
//       return `Up to ₹${(enquiry.max_budget/100000).toLocaleString()}L`;
//     }
//     // Fallback to single budget field
//     return enquiry.budget ? `₹${(enquiry.budget/100000).toLocaleString()}L` : "Not specified";
//   };

//   if (loading) return <div>Loading...</div>;
//   if (!property) return <div>Property not found</div>;

//   return (
//     <Box sx={{ 
//       display: 'flex',
//       flexDirection: 'column',
//       minHeight: '100vh',
//       background: `
//         linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
//         url('https://www.transparenttextures.com/patterns/cream-paper.png')
//       `,
//       backgroundSize: 'cover',
//       backgroundAttachment: 'fixed',
//       overflow: 'hidden'
//     }}>
//       <AppBar 
//         position="static" 
//         elevation={0}
//         sx={{ 
//           background: `
//             linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
//             url('https://www.transparenttextures.com/patterns/dark-matter.png')
//           `,
//           color: 'text.primary',
//           boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
//         }}
//       >
//         <Toolbar sx={{ minHeight: 64 }}>
//           <IconButton 
//             edge="start" 
//             onClick={() => navigate(-1)}
//             sx={{ 
//               color: '#ffffff',
//               backgroundColor: 'rgba(255,255,255,0.1)',
//               '&:hover': { 
//                 backgroundColor: 'rgba(255,255,255,0.2)' 
//               }
//             }}
//           >
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white' }}>
//             Matching Buyers ({buyers.length})
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       <Container 
//         sx={{ 
//           py: 3,
//           flex: 1,
//           overflow: 'auto',
//           mb: 7
//         }}
//       >
//         <Card sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: 3 }}>
//           <CardContent>
//             {buyers.length > 0 ? (
//               <List sx={{ width: '100%', maxHeight: '100%', overflow: 'auto' }}>
//                 {buyers.map((buyer) => (
//                   <React.Fragment key={buyer.enqid}>
//                     <ListItem alignItems="flex-start" sx={{ py: 2 }}>
//                       <ListItemText
//                         primary={
//                           <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                             {buyer.user?.username || "Anonymous Buyer"}
//                           </Typography>
//                         }
//                         secondary={
//                           <React.Fragment>
//                             <Typography variant="body2" color="text.primary">
//                               Mobile: {buyer.user?.mobile_no || "Not provided"}
//                             </Typography>
//                             <Typography variant="body2" color="text.primary">
//                               Email: {buyer.user?.email || "Not provided"}
//                             </Typography>
//                             <Typography variant="body2" color="text.primary">
//                               Looking for: {buyer.property_type}
//                             </Typography>
//                             <Typography variant="body2" color="text.primary">
//                               Preferred Area: {buyer.area}
//                             </Typography>
//                             <Typography variant="body2" color="text.primary">
//                               Budget: {buyer.formattedBudget}
//                             </Typography>
//                             <Typography variant="body2" color="text.primary">
//                               Distance from property: {buyer.distance}
//                             </Typography>
//                             <Typography variant="caption" color="text.secondary">
//                               Enquiry Date: {new Date(buyer.created_at).toLocaleDateString()}
//                             </Typography>
//                           </React.Fragment>
//                         }
//                         sx={{ ml: 0 }}
//                       />
//                     </ListItem>
//                     <Divider component="li" />
//                   </React.Fragment>
//                 ))}
//               </List>
//             ) : (
//               <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <Typography variant="h6" color="text.secondary">
//                   No matching buyers found for this property
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                   (Must match property type, budget range, and be within 10km radius)
//                 </Typography>
//               </Box>
//             )}
//           </CardContent>
//         </Card>
//       </Container>

//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
//         <FormsBottomNavbar /> 
//       </Box>
//     </Box>
//   );
// };

// export default MatchingBuyersPage;




import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Card,
  CardContent,
  CircularProgress,
  Button
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../Api/ApiUrls';

const MatchingBuyersPage = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const [buyers, setBuyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [users, setUsers] = useState([]);
  const [property, setProperty] = useState(null);

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // 10% range logic for budget matching
  const isBudgetInRange = (propertyPrice, minBudget, maxBudget) => {
    if (!propertyPrice) return false;

    // If both min and max budget are provided
    if (minBudget && maxBudget) {
      const range = (maxBudget - minBudget) * 0.10; // 10% of the budget range
      const extendedMin = Math.max(0, minBudget - range);
      const extendedMax = maxBudget + range;
      
      return propertyPrice >= extendedMin && propertyPrice <= extendedMax;
    }
    
    // If only min budget is provided
    if (minBudget && !maxBudget) {
      const extendedMin = minBudget * 0.90; // 10% below min budget
      return propertyPrice >= extendedMin;
    }
    
    // If only max budget is provided
    if (!minBudget && maxBudget) {
      const extendedMax = maxBudget * 1.10; // 10% above max budget
      return propertyPrice <= extendedMax;
    }
    
    return false;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const propertiesResponse = await axios.get(`${BASE_URL}/property/`);
        const foundProperty = propertiesResponse.data.find(p => p.property_id == propertyId);
        if (!foundProperty) {
          setLoading(false);
          return;
        }
        setProperty(foundProperty);

        const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesResponse.data);

        const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
        const allEnquiries = enquiriesResponse.data;

        const usersResponse = await axios.get(`${BASE_URL}/users/`);
        setUsers(usersResponse.data);

        const propertyCategory = categoriesResponse.data.find(cat => cat.category_id == foundProperty.category_id)?.category;

        const parseCoord = (coord) => {
          if (!coord) return null;
          const cleaned = coord.replace(/"/g, '').replace(':', '.');
          return parseFloat(cleaned);
        };

        const propLat = parseCoord(foundProperty.lat);
        const propLong = parseCoord(foundProperty.long);

        const matchingBuyers = allEnquiries.filter(enquiry => {
          const enquiryUser = usersResponse.data.find(user => user.user_id == enquiry.user_id);
          if (!enquiryUser) return false;

          const typeMatch = enquiry.property_type && propertyCategory &&
            enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();

          // Updated budget matching with 10% range logic
          const budgetMatch = isBudgetInRange(
            foundProperty.price, 
            enquiry.min_budget, 
            enquiry.max_budget
          );

          const locationMatch = (() => {
            if (!propLat || !propLong || !enquiry.lat || !enquiry.long) return false;
            try {
              const enqLat = parseFloat(enquiry.lat);
              const enqLong = parseFloat(enquiry.long);
              const distance = calculateDistance(propLat, propLong, enqLat, enqLong);
              return distance <= 10;
            } catch {
              return false;
            }
          })();

          return typeMatch && budgetMatch && locationMatch;
        }).map(enquiry => ({
          ...enquiry,
          user: usersResponse.data.find(user => user.user_id == enquiry.user_id),
          formattedBudget: formatBudgetDisplay(enquiry),
          distance: (() => {
            if (!propLat || !propLong || !enquiry.lat || !enquiry.long) return 'N/A';
            try {
              const enqLat = parseFloat(enquiry.lat);
              const enqLong = parseFloat(enquiry.long);
              return `${calculateDistance(propLat, propLong, enqLat, enqLong).toFixed(1)} km`;
            } catch {
              return 'N/A';
            }
          })()
        }));

        setBuyers(matchingBuyers);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [propertyId]);

  const formatBudgetDisplay = (enquiry) => {
    if (enquiry.min_budget && enquiry.max_budget) {
      const minInLakhs = enquiry.min_budget / 100000;
      const maxInLakhs = enquiry.max_budget / 100000;
      
      // Convert to Cr if above 1 Cr (100 Lakhs)
      if (minInLakhs >= 100 || maxInLakhs >= 100) {
        const minInCr = enquiry.min_budget / 10000000;
        const maxInCr = enquiry.max_budget / 10000000;
        return `₹${minInCr.toFixed(2)}Cr - ₹${maxInCr.toFixed(2)}Cr`;
      }
      
      return `₹${minInLakhs.toLocaleString()}L - ₹${maxInLakhs.toLocaleString()}L`;
    }
    if (enquiry.min_budget && !enquiry.max_budget) {
      const minInLakhs = enquiry.min_budget / 100000;
      if (minInLakhs >= 100) {
        return `₹${(enquiry.min_budget / 10000000).toFixed(2)}Cr+`;
      }
      return `₹${minInLakhs.toLocaleString()}L+`;
    }
    if (!enquiry.min_budget && enquiry.max_budget) {
      const maxInLakhs = enquiry.max_budget / 100000;
      if (maxInLakhs >= 100) {
        return `Up to ₹${(enquiry.max_budget / 10000000).toFixed(2)}Cr`;
      }
      return `Up to ₹${maxInLakhs.toLocaleString()}L`;
    }
    return enquiry.budget ? `₹${(enquiry.budget / 100000).toLocaleString()}L` : "Not specified";
  };

  if (loading) {
    return <Box textAlign="center" mt={4}><CircularProgress /></Box>;
  }

  if (!property) return <div>Property not found</div>;

  return (
     <Box
      sx={{
        minHeight: '100vh',
        pb: 8,
        backgroundImage:
          'linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95))',
      }}
    >
      {/* Top App Bar */}
      <AppBar position="static" sx={{ backgroundColor: '#000' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2 }}>
            Matching Buyers ({buyers.length})
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Matching Buyers Container */}
      <Container sx={{ py: 3 }}>

        {buyers.length === 0 ? (
          <Typography align="center" color="text.secondary" mt={5}>
            No matching buyers found.
          </Typography>
        ) : (
          buyers.map((buyer) => (
            <Card
              key={buyer.enqid}
              sx={{
                mb: 3,
                p: 2,
                borderRadius: 3,
                boxShadow: 4,
                backgroundColor: '#fff',
              }}
            >
              <Typography variant="h5" align='center' sx={{ mt: 2,mb: 2 }}>
            Matching Buyers Details
          </Typography>

              <Card
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  backgroundColor: '#f9f9f9',
                  boxShadow: 1,
                }}
              >
                 <Typography variant="body2">
                  <b>Name</b> {buyer.user?.username || 'Anonymous Buyer'}
                </Typography>
                 <Typography variant="body2">
                    <b>Email</b> {buyer.user?.email || 'N/A'}
                </Typography>
                <Typography variant="body2">
                  <b>Looking for:</b> {buyer.property_type}
                </Typography>
                <Typography variant="body2">
                  <b>Preferred Area:</b> {buyer.area}
                </Typography>
                <Typography variant="body2">
                  <b>Budget:</b> {buyer.formattedBudget}
                </Typography>
                <Typography variant="body2">
                  <b>Distance from property:</b> {buyer.distance}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: 'block', mt: 1 }}
                >
                  Enquiry Date: {new Date(buyer.created_at).toLocaleDateString()}
                </Typography>

                 <Box textAlign="center">
                <Box
                  onClick={() => {
                    const phone = buyer.user?.mobile_no || 'N/A';
                    navigator.clipboard.writeText(phone);
                    alert(`Phone number ${phone} copied!`);
                  }}
                  sx={{
                    backgroundColor: '#e53935',
                    color: '#fff',
                    py: 1,
                    mt: 2,
                    borderRadius: '20px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#d32f2f',
                    },
                  }}
                >
                  📞 {buyer.user?.mobile_no || 'N/A'} (Tap to Copy)
                </Box>
              </Box>
              </Card>

              
            </Card>
          ))
        )}
      </Container>

      {/* Bottom Navbar */}
      <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};
export default MatchingBuyersPage;
